module.exports = __webpack_public_path__ + "static/media/julia.b63dac6d.jpeg";